import * as general from './general';
import * as user from './user';

export const userSelector = user;
export const generalSelector = general;
